import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../config';
import './EventBooking.css';

const EventBooking = () => {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    company: '',
    email: '',
    phone: '',
    guests: '',
    address: '',
    date: '',
    start_time: '',
    end_time: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResult(null);

    try {
      await axios.post(`${BASE_URL}/api/event-booking/`, form);
      setResult({ type: 'success', text: 'Thank you! Your booking request has been sent. We will get back to you shortly.' });
      setForm({
        first_name: '', last_name: '', company: '', email: '', phone: '',
        guests: '', address: '', date: '', start_time: '', end_time: '', message: '',
      });
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      setResult({ type: 'error', text: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="evbook-page">
      <div className="evbook-hero">
        <h1 className="evbook-hero-title">Hire a barista for your event</h1>
      </div>

      <div className="evbook-card">
        <h2 className="evbook-card-title">We look forward to your event inquiry!</h2>
        <p className="evbook-card-subtitle">
          Once we receive your information, we will get back to you with our offer.
        </p>

        <form onSubmit={handleSubmit} className="evbook-form">
          <div className="evbook-row">
            <input name="first_name" value={form.first_name} onChange={handleChange} placeholder="First Name" className="evbook-input" />
            <input name="last_name" value={form.last_name} onChange={handleChange} placeholder="Last Name *" required className="evbook-input" />
          </div>

          <input name="company" value={form.company} onChange={handleChange} placeholder="Company" className="evbook-input evbook-full" />

          <div className="evbook-row">
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email *" required className="evbook-input" />
            <input name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="Phone *" required className="evbook-input" />
          </div>

          <div className="evbook-row">
            <input name="guests" type="number" min="1" value={form.guests} onChange={handleChange} placeholder="Number of Guests *" required className="evbook-input" />
            <input name="address" value={form.address} onChange={handleChange} placeholder="Event Address" className="evbook-input" />
          </div>

          <div className="evbook-field evbook-full">
            <label className="evbook-label">Event Date *</label>
            <input name="date" type="date" value={form.date} onChange={handleChange} required className="evbook-input evbook-full" />
          </div>

          <div className="evbook-row">
            <div className="evbook-field">
              <label className="evbook-label">Event Start *</label>
              <select name="start_time" value={form.start_time} onChange={handleChange} required className="evbook-input">
                <option value="">Select time</option>
                {Array.from({ length: 24 }, (_, i) => { const t = `${String(i).padStart(2, '0')}:00`; return <option key={t} value={t}>{t}</option>; })}
              </select>
            </div>
            <div className="evbook-field">
              <label className="evbook-label">Event End *</label>
              <select name="end_time" value={form.end_time} onChange={handleChange} required className="evbook-input">
                <option value="">Select time</option>
                {Array.from({ length: 24 }, (_, i) => { const t = `${String(i).padStart(2, '0')}:00`; return <option key={t} value={t}>{t}</option>; })}
              </select>
            </div>
          </div>

          <textarea name="message" value={form.message} onChange={handleChange} placeholder="Message" rows="4" className="evbook-input evbook-full evbook-textarea" />

          {result && (
            <div className={`evbook-result ${result.type}`}>{result.text}</div>
          )}

          <button type="submit" className="evbook-submit" disabled={submitting}>
            {submitting ? 'Sending…' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EventBooking;
